import React from "react";
import OptionDetails from "../optionDetails/OptionDetails";

const NscOptions = (props) => {
  return <OptionDetails optionsData={props.options} {...props} />;
};

export default NscOptions;
